import { RootErrorBoundary } from '@data-delivery/permission-ui-shared-ui';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { routeDefinitions } from './routes/route-definitions';

const router = createBrowserRouter(routeDefinitions);

export const AppRouter: React.FC = () => (
  <RootErrorBoundary>
    <RouterProvider router={router} />
  </RootErrorBoundary>
);
